import { throttle } from 'throttle-debounce';
import * as React from 'react';
import { getScrollTop } from './scroll';

export interface IScrollFoldingProps {
  onFoldChange(hidden: boolean): void;
}

interface ISCrollFoldingState {
  hidden?: boolean;
}

export class ScrollFolding extends React.Component<React.PropsWithChildren<IScrollFoldingProps>, ISCrollFoldingState> {
  public state: ISCrollFoldingState = {
    hidden: false,
  };

  private lastScrollTop = 0;

  public componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  public render() {
    return this.props.children;
  }

  private handleScroll = throttle(50, () => {
    const currentScrollTop = getScrollTop();

    const shouldHide = this.lastScrollTop < currentScrollTop;
    this.setState({ hidden: shouldHide });
    this.props.onFoldChange(shouldHide);

    this.lastScrollTop = currentScrollTop;
  });
}
